import { Component, OnInit, ViewEncapsulation, Input, NgZone, Renderer2, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription, fromEvent, Subject } from 'rxjs';
import { DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { v_DispatchPartBus } from '../../../shared/models/v_DispatchPartBus';
import { take, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { BaseGridEditLineComponent } from '../../../shared/base-components/base-grid-editline.component';
import { DispatchPartsBus } from '../../../shared/models/DispatchPartsBus';
import { DispatchPartsMessageInfo } from '../../../shared/models/DispatchPartsMessageInfo';
import { InventoryService } from '../../../shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DispatchAssignmentBus } from '../../../shared/models/DispatchAssignmentBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonParam } from '../../../shared/models/CommonParam';
import { CommonValues } from '../../../shared/static/CommonValues';
import { v_InventoryBus } from '../../../shared/models/v_InventoryBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-parts',
    templateUrl: './dispatch-parts.component.html',
    styleUrls: ['./dispatch-parts.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DispatchPartsComponent extends BaseGridEditLineComponent<v_DispatchPartBus, null, DispatchesService> implements OnInit {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    @Input() canDrag: boolean = false;
    @Input() assignmentData: DispatchAssignmentBus[] ;
    renderer: Renderer2;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private destroy$ = new Subject();
    private currentSubscription: Subscription;

    constructor(globals: GlobalsService, renderer: Renderer2, private zone: NgZone, cd: ChangeDetectorRef, svc_data: DispatchesService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "v_DispatchPartBus";
        this.appCode = "DispatchPart";
        this.appName = "Dispatch Parts Used";

        this.inventorySvcField = "number";
    }
    override ngOnInit() {
        super.ngOnInit();
        if (this.hasReferenceData) {
            this.inventoryLocations = _.cloneDeep(this.referenceData.warehouses);
        }
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchPartsRequestId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'addToOrder': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl('', Validators.required),
            'number': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'fullDescription': new UntypedFormControl(),
            'inventoryLocationId': new UntypedFormControl('', Validators.required),
            'inventoryLocationName': new UntypedFormControl(),
            'qtyInStock': new UntypedFormControl(),
            'quantity': new UntypedFormControl('', Validators.required),
            'usedPartQuantity': new UntypedFormControl(),
            'lastSupplier': new UntypedFormControl(),
            'addedDate': new UntypedFormControl(),
            'isXfered': new UntypedFormControl(),
            'isWrongPart': new UntypedFormControl(),
            'needsReplacement': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'personId': new UntypedFormControl('', Validators.required),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'warehouse': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),

        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchPartId: this.selectedData.dispatchPartId,
            dispatchId: this.selectedData.dispatchId,
            inventoryId: this.selectedData.inventoryId,
            number: this.selectedData.number,
            inventoryDesc: this.selectedData.inventoryDesc,
            fullDescription: this.selectedData.fullDescription,
            fromInventoryLocationId: this.selectedData.inventoryLocationId,
            inventoryLocationId: this.selectedData.inventoryLocationId,
            inventoryLocationName: this.selectedData.inventoryLocationName,
            quantity: this.selectedData.quantity,
            addedDate: this.selectedData.addedDate,
            personName: this.selectedData.personName,
            personId: this.selectedData.personId,
            warehouse: this.selectedData.warehouse,
            qtyInStock: this.selectedData.qtyInStock
            //insertDt: this.selectedData.insertDt,
            //insertUserId: this.selectedData.insertUserId,
            //updateDt: this.selectedData.updateDt,
            //updateUserId: this.selectedData.updateUserId
        });
        if (CommonFunctions.hasGuidValue(this.selectedData.inventoryId)) {
            let invLocations = this.invLocs.getParam(this.selectedData.inventoryId.toString());
            if (CommonFunctions.hasArrayElementValue(invLocations)) {
                this.inventoryLocations = invLocations;
            }
            else {
                this.setInventoryLocations();
            }
        }
        else {
            this.setInventoryLocations();
        }
    }
    clear() {
        super.clear();
        this.invLocs = new CommonParam();
    }
    setFromReferenceData(data: v_DispatchPartBus) {
        data.warehouse = this.referenceData.getWarehouse(data.inventoryLocationId);
        return data;
    }
    invLocs: CommonParam = new CommonParam();
    get inventoryLocationId(): any {
        let inventoryLocationId: any = null;
        try {
            if (this.hasEditForm) {
                inventoryLocationId = this.editForm.value.inventoryLocationId;
            }
        }
        catch{

        }
        return inventoryLocationId;
    }
    personCBOChanged(e: GItem) {

        this.editForm.patchValue({
            personId: e.value,
            personName: e.description
        }
        )

    }
    invLocCBOChanged(e: any) {
        this.editForm.patchValue({
            inventoryLocationId: e.value,
            warehouseName: e.description,

        });
        if (this.selectedData.inventoryLocationId != e.value) {
            this.selectedData.inventoryLocationXREFId = CommonValues.Guid_Empty;
        }
        if (this.compFeatureFlagSet.featureFlagSet['dispatch-screen-parts-used-tab-add-a-new-column-for-stk-qty']) {

            this.svc_inv.getLocationQuantity(this.selectedData.inventoryId, e.value).subscribe((data: number) => {
                this.setQuantityInStock(data);

            });
        }
    }
    setQuantityInStock(newQtyInStock: number) {
        this.editForm.patchValue({
            qtyInStock: newQtyInStock
        });

    }
    getChangedObject(dataObj: v_DispatchPartBus) {
        let busObj: DispatchPartsBus = new DispatchPartsBus();
        busObj.setFromView(dataObj);
        if (!CommonFunctions.hasGuidValue(busObj.inventoryLocationXrefid)) {
            busObj.inventoryLocationXrefid = CommonValues.Guid_Empty;
        }
        busObj.setBeforeSave();
        return busObj;
    }
    afterAddNewData() {

        if (this.selectedData) {
            this.selectedData.inventoryLocationId = null;
            this.selectedData.personId = this.globals.personId;
        }
        //if (this.selectedData) {
        //    if (this.assignmentData && this.assignmentData.length > 0) {
        //        var personId = this.assignmentData[0].assignedPersonId
        //        var inventoryLocationId = this.referenceData.getPersonLocationId(personId);
        //        this.selectedData.personId = personId;
        //        if (inventoryLocationId) {
        //            this.selectedData.inventoryLocationId = inventoryLocationId;

        //        }
        //    }

        //}

    }
    protected save(dataObj: v_DispatchPartBus) {

        let busObj: DispatchPartsBus = this.getChangedObject(dataObj);

        this.svc_data.savePartsRequest(busObj).subscribe((data: DispatchPartsMessageInfo) => {
            if (!data.saveError) {
                let newDataObj: v_DispatchPartBus = new v_DispatchPartBus(data.dispatchPartsView);
                this.saveSuccess(newDataObj);
            }
            else {
                this.saveError(dataObj, data.message);
            }
        })
    }
    deleteIndividual(data: v_DispatchPartBus) {
        if (data.hasId) {
            this.svc_data.deletePartsRequest(data.dispatchPartId).subscribe((dataObj: DispatchPartsMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
        //this.svc_data.deleteInvoiceLine(data.invoiceLineId).subscribe((retData: InvoiceMessageInfo) => {
        //    if (retData.saveError) {
        //        this.notify(CommonValues.Message_ErrorDeleting + " - " + retData.message, 'E');
        //    }
        //    else {
        //        this.removeLocal(data);
        //        this.notify(CommonValues.Message_SuccessfullyDeleted);

        //    }
        //});

    }
    canEditRow(dataItem: v_DispatchPartBus) {
        return super.canEditRow(dataItem) && CommonFunctions.hasValue(dataItem) && (!dataItem.onConstDraw || this.rights.FinancialLockOverride);
    }

    /// drag and Drop
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }

    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].personName) {
                    this.gridData[i].personName = this.personName(this.gridData[i].personId);
                }
                if (!this.gridData[i].warehouse) {
                    this.gridData[i].warehouse = this.warehouseName(this.gridData[i].inventoryLocationId);

                }
            }
        }
        this.getDragReady();

    }
    public warehouse(id: string) {
        //this.warehouseCount = this.warehouseCount + 1;

        let retVal: any;
        if (CommonFunctions.hasValue(this.referenceData)) {
            retVal = this.inventoryLocations.find(x => x.value === id);
        }
        return retVal;
    }
    public warehouseName(id: string) {
        //this.warehouseNameCount = this.warehouseNameCount + 1;

        let data: GItem = this.warehouse(id);
        let name = "";
        if (CommonFunctions.hasValue(data)) {
            name = data.description;
        }
        return name;
    }
    public ngAfterViewInit(): void {
        if (this.canDrag) { this.currentSubscription = this.handleDragAndDrop(); }
    }
    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.partsUsedGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {

                        //const dragImgEl = document.createElement('span');
                        //dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
                        //document.body.appendChild(dragImgEl);
                        //dataTransfer.setDragImage(dragImgEl, 0, 0);
                    } catch (err) {
                        // IE doesn't support setDragImage
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
                //   dataItem.dragging = true;
            }));

            //sub.add(dragOver.subscribe((e: any) => {
            //    e.preventDefault();
            //    const dataItem = this.gridData.data.splice(draggedItemIndex, 1)[0];
            //    const dropIndex = closest(e.target, tableRow).rowIndex;
            //    const dropItem = this.gridData.data[dropIndex];

            //    draggedItemIndex = dropIndex;
            //    this.zone.run(() =>
            //       // this.gridData.data.splice(dropIndex, 0, dataItem)
            //    );
            //}));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 2;
                event.dropid = event.dispatchPartId

                this.dropEvent.emit(event);
                // const dataItem = this.gridData.data[draggedItemIndex];
                //   dataItem.dragging = false;
            }));
        });

        return sub;
    }
    protected beforeInventorySearchSetForm() {
        if (CommonFunctions.hasGuidValue(this.lastInventoryLocationId)) {
            this.selectedData.inventoryLocationId = this.lastInventoryLocationId;
        }
        else {
            this.setInventoryLocations();
        }
    }
    setInventoryLocations() {
        if (CommonFunctions.hasGuidValue(this.selectedData.inventoryId)) {
            this.svc_inv.getInventoryLocationsForInventoryItem(this.selectedData.inventoryId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError && CommonFunctions.hasValue(info.primaryReturn)) {
                    let arr = [];
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: GItem = new GItem();
                        newObj.description = info.primaryReturn[i].description;
                        newObj.value = info.primaryReturn[i].id;
                        arr.push(newObj);
                    }
                    this.inventoryLocations = arr;
                    this.invLocs.addParam(this.selectedData.inventoryId.toString(), this.inventoryLocations);
                }
                else {
                    this.inventoryLocations = _.cloneDeep(this.referenceData.warehouses);
                }
            });
        }
        else {
            this.inventoryLocations = _.cloneDeep(this.referenceData.warehouses);
        }
    }
    protected beforeInventorySearchChangeInvItem(data: v_InventoryBus) {
        if (this.selectedData.inventoryId !== data.inventoryId) {
            this.selectedData.inventoryLocationXREFId = CommonValues.Guid_Empty;
        }
    }
    protected afterSetInventorySearchData() {
        try {
            if (this.hasGridData && this.hasEditForm) {
                this.gridData[this.editedRowIndex].inventoryDesc = this.selectedData.inventoryDesc;
                this.gridData[this.editedRowIndex].fullDescription = this.selectedData.fullDescription;
            }
        }
        catch (err) {

        }
    }
    lastInventoryLocationId: any = null;
    override setInventorySearchData(value: any) {
        this.lastInventoryLocationId = this.inventoryLocationId;
        super.setInventorySearchData(value);
    }
    inventoryLocations: GItem[];

    rowCallback(context: RowClassArgs) {
        if (context.dataItem)
            return {
                onConstDraw: context.dataItem.onConstDraw,
                inFinance: !context.dataItem.onConstDraw && context.dataItem.inFinance
            };
        return {};
    }
    canDelete(dataItem: v_DispatchPartBus): boolean {
        return dataItem.inFinance ? this.rights.FinancialLockOverride : true;
    }

}
